Vue.component('product-item', {
    props: {
        currentProductId: Number,
        rawData: Object,
        sizePrice: Number,
        sizeOldPrice: Number,
        minimal: Number,
        proteins: Number,
        fats: Number,
        carbohydrate: Number,
    },
    data() {
        return {
            productId: null,
            doughType: null,
            weight: null,
            count: 1,
            price: null,
            oldPrice: null,
            proteinsData: null,
            fatsData: null,
            carbohydrateData: null,
        };
    },
    computed: {
        totalPrice() {
            return this.price * this.count;
        }
    },
    methods: {
        getProduct() {
            return store.state.products[this.productId];
        },
        setProductId(weight, doughType) {
            this.productId = null;
            let candidate = null;
            let candidateIndex = null;
            for (let index in this.rawData) {
                let datum = this.rawData[index];
                if (datum.doughType == doughType) {
                    if (datum.weight == weight) {
                        this.productId = +index;
                        this.proteinsData = datum.proteins;
                        this.fatsData = datum.fats;
                        this.carbohydrateData = datum.carbohydrate;
                        break;
                    } else {
                        candidate = datum;
                        candidateIndex = index;
                    }
                }

            }

            this.doughType = doughType;
            this.weight = weight;
            if (this.productId === null) {
                this.productId = +candidateIndex;
                this.weight = candidate.weight;
            }
            this.price = store.state.products[this.productId].price;
            this.oldPrice = store.state.products[this.productId].old_price;
            let _this = this;
            this.count = store.state.order.items.reduce(function (value, item) {
                if (item.product.id == _this.productId) {
                    return item.count;
                }
                return value;
            }, this.minimal);
        },
        isAvailableWeight(weight) {
            for (let index in this.rawData) {
                let datum = this.rawData[index];
                if (datum.doughType == this.doughType && datum.weight == weight) {
                    return true;
                }
            }
            return false;
        },
        changeWeight(weight) {
            this.setProductId(weight, this.doughType);
        },
        changeDoughType(type) {
            this.setProductId(this.weight, type);
        },
        addInCart() {
            try {
                fbq('track', 'AddToCart', {
                    value: this.price * this.count, //коллчиество пирогов
                    currency: 'RUB', // RUR - так нужно значение сделать
                    contents: [
                        {
                            id: this.productId, // ID ТОВАРОА
                            quantity: this.count // КОЛЛИЧЕСТВО ТОВАРА
                        }
                    ],
                });
            } catch (e) {}
            store.dispatch('setItemInCart', {product_id: this.productId, count: this.count});
        },
        addItems() {
            this.count = ProductHelper.changeCount(this.getProduct(), this.count + 1);
        },
        reduceItems() {
            if (this.count > 1) {
                this.count = ProductHelper.changeCount(this.getProduct(), this.count - 1, true);
            }
        },
        changeItems() {
            this.count = ProductHelper.changeCount(this.getProduct(), this.count);
        },
        changeCount(direction) {
            let newCount = this.count + direction;
            if (newCount < this.minimal) {
                newCount = this.minimal;
            }
            this.count = newCount;
        },
        formatPrice(price) {
            return NumberHelper.format(price);
        }
    },
    created() {
        this.productId = this.currentProductId;
        this.doughType = this.rawData[this.productId].doughType;
        this.weight = this.rawData[this.productId].weight;
        this.price = this.sizePrice;
        this.count = this.minimal;
        this.oldPrice = this.sizeOldPrice;
        this.proteinsData = this.proteins;
        this.fatsData = this.fats;
        this.carbohydratData = this.carbohydrate;
    },
});